// README: The order everything is "exposed" is important. If a module that's being exposed as a global
// variable imports another exposed module, the dependency needs to be exposed first. This will allow
// the module with the dependency to load it from the global variable rather than importing again.
import configureBugsnag from "common/initializers/bugsnag";
import "core-js/stable"; // Imports polyfills based on targets specified by .browserslistrc
import "mdn-polyfills/Node.prototype.append"; // Adds support for Internet Explorer 11 (IE 11)
import "./common.css";

// Configures the Bugsnag client to group and ignore specific errors
configureBugsnag();

// Third Party Libraries
global.React = require("externals/react");
global.ReactDOM = require("externals/react-dom");

// This can be removed when `createReactClass` is no longer being used in app/assets/javascripts
global.createReactClass = require("externals/create-react-class");
global.PropTypes = require("externals/prop-types");

// React UJS needs to be loaded before exposing jQuery to avoid using jQuery 1.x/2.x ready handlers
global.ReactRailsUJS = require("externals/react_ujs");
global.$ = require("externals/jquery");
global.jQuery = global.$;
global.jQueryUJS = require("externals/jquery-ujs");
global.moment = require("externals/moment-mini");
global.momentTimezone = require("vendor/moment-timezone");

// Common Utilities
global.i18n = require("common/utils/i18n").default;
global.growl = require("common/utils/growl").default;
global.SimpleStorage = require("common/utils/simple-storage").default;
global.TimeZone = require("common/utils/time-zone").default;

// External Components
global.StatusIndicator = require("externals/@simplymadeapps/simpleinout-status-indicator");
global.Avatar = require("externals/@simplymadeapps/simpleinout-avatar");
global.Phone = require("externals/@simplymadeapps/simpleinout-phone");

// Common React Components
global.Button = require("common/components/button").default;
global.CheckBox = require("common/components/checkbox").default;
global.ConfirmToEditInput = require("common/components/confirm-to-edit-input").default;
global.CsrfToken = require("common/components/csrf-token").default;
global.DatePicker = require("common/components/date-picker").default;
global.DowntimeNotification = require("common/components/downtime-notification").default;
global.FileAndSubmitField = require("common/components/file-and-submit-field").default;
global.FilterSelect = require("common/components/filter-select").default;
global.Growl = require("common/components/growl").default;
global.HelpIcon = require("common/components/help-icon").default;
global.MailingListSubscriptionButton = require("common/components/mailing-list-subscription-button").default;
global.ModalComponents = require("common/components/modal");
global.Modal = global.ModalComponents.default;
global.ModalBody = global.ModalComponents.ModalBody;
global.ModalFooter = global.ModalComponents.ModalFooter;
global.ModalHeader = global.ModalComponents.ModalHeader;
global.SelectToDisableFields = require("common/components/select-to-disable-fields").default;
global.Switch = require("common/components/switch").default;
global.TimeZoneSelect = require("common/components/time-zone-select").default;

// Run the initializer scripts
const initializer = require("common/initializers/jquery");
global.onAjaxError = initializer.onAjaxError;
